import type { PopoverProps } from '@launchpad-ui/components';

import { AnnouncementPopover } from './AnnouncementPopover';
import { availableAnnouncements } from './availableAnnouncements';

type OneTimeAnnouncementProps = {
  /** Popover placement relative to the anchor. */
  placement?: PopoverProps['placement'];
};

/**
 * Renders the first *enabled* announcement from the catalog, so callers don't pick
 * an announcement key. Each announcement is gated by its own dogfood flag via
 * `Announcement.enabled`; the chosen `AnnouncementPopover` enforces the
 * once-per-member dismissal.
 *
 * Renders nothing when no announcement is enabled. Mount this once, behind the
 * system-level `enable-one-time-announcement-system` flag (see AppShell).
 */
export function OneTimeAnnouncement({ placement }: OneTimeAnnouncementProps) {
  const announcement = availableAnnouncements.find((candidate) => candidate.enabled);
  if (!announcement) {
    return null;
  }

  return <AnnouncementPopover announcementKey={announcement.key} placement={placement} />;
}
